import React from 'react';

const MessageModal = ({ message, onConfirm, onCancel, showCancel = false }) => {
  if (!message) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.2rem', margin: '1rem 0', whiteSpace: 'pre-wrap' }}>{message}</p>
        <div className="form-actions" style={{justifyContent: 'center'}}>
            {showCancel && (
                <button type="button" className="cancel-button" onClick={onCancel}>
                    Cancel
                </button>
            )}
            <button type="button" className="submit-button" onClick={onConfirm}>
                {showCancel ? 'Yes' : 'OK'}
            </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
